export const bills = '/bills/donations';
export const payments = '/payments/donations';
export const download = '/payments/donations/download';
